import React from 'react';
import type { Accion, Referencia } from './tipos';
import { useGuardadoCoordinado } from './useGuardadoCoordinado';

const OPCIONES: Array<{ accion: Accion; label: string; activo: string }> = [
  { accion: 'aceptar', label: 'Nada', activo: 'bg-green-600 text-white' },
  { accion: 'regenerar', label: 'Rehacer', activo: 'bg-red-600 text-white' },
  { accion: 'pedir_fotos', label: 'Pedir fotos', activo: 'bg-amber-500 text-white' },
];

/**
 * El análisis de Matías para UNA imagen (independiente de la corrida): acción correcta +
 * texto. Guarda al elegir acción (click de nuevo la borra) y al blur del texto; sin
 * acción elegida el texto no viaja (lo dice el placeholder). Click y blur se coordinan
 * en useGuardadoCoordinado (el blur del textarea dispara ANTES del click del botón).
 */
const MiAnalisis: React.FC<{
  referencia: Referencia | undefined;
  onGuardar: (accion: Accion | null, texto: string) => Promise<void>;
}> = ({ referencia, onGuardar }) => {
  const g = useGuardadoCoordinado<Accion>({
    accion: referencia?.accion ?? null,
    texto: referencia?.texto ?? '',
    version: referencia?.updated_at,
    guardar: onGuardar,
  });

  return (
    <div className="rounded-lg border border-dashed border-gray-300 p-2">
      <div className="mb-1 flex flex-wrap items-center gap-2">
        <span className="text-[11px] font-semibold uppercase tracking-wide text-gray-500">Mi análisis</span>
        {OPCIONES.map((o) => (
          <button
            key={o.accion}
            type="button"
            onMouseDown={g.onMouseDownBoton}
            onClick={() => void g.elegir(o.accion)}
            className={`rounded-full py-1.5 px-3 text-xs font-medium ${g.accion === o.accion ? o.activo : 'border border-gray-300 bg-white text-brand-black'}`}
          >
            {o.label}
          </button>
        ))}
        {g.guardando && <span className="text-[11px] text-gray-500">Guardando…</span>}
      </div>
      <textarea
        value={g.texto}
        onChange={(e) => g.setTexto(e.target.value)}
        onBlur={g.onBlur}
        rows={2}
        placeholder={g.accion ? 'Qué está mal (o por qué está bien) — guarda al salir del campo' : 'Elegí primero Nada / Rehacer / Pedir fotos; el texto se guarda junto con la acción'}
        className="w-full rounded-md border border-gray-300 py-1.5 px-2 text-xs text-brand-black"
      />
      {g.error && <p className="mt-1 text-xs text-red-600">{g.error}</p>}
    </div>
  );
};

export default MiAnalisis;
